var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484C52",
    d: "M19.958,9.736c-0.531-2.575-4.784-5.783-9.953-5.783c-5.154,0-9.398,3.296-9.949,5.783 c0,0-0.025,0.178-0.025,0.264s0.021,0.264,0.021,0.264c0.532,2.575,4.785,5.783,9.954,5.783c5.153,0,9.397-3.297,9.949-5.783 c0,0,0.015-0.182,0.015-0.287C19.969,9.872,19.958,9.736,19.958,9.736z M10,14.931c-2.686,0-4.863-2.208-4.863-4.931 S7.314,5.07,10,5.07c2.686,0,4.863,2.208,4.863,4.93S12.686,14.931,10,14.931z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#484C52",
    cx: 10,
    cy: 10,
    r: 2.938
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShow);
export default __webpack_public_path__ + "static/media/icon-show.091d32d9.svg";
export { ForwardRef as ReactComponent };